import React, { useState, useContext } from "react";
import { motion } from "framer-motion";
// import background_image from "../../../assets/background9.jpg";
// import coach from "../../../assets/gurdian_angel.jpg";
import { UserContext } from "../../../UserContext";
import stars from "../../../assets/stars.png";
import Vector2 from "../../../assets/Vector2.png";
import Panda2 from "../../../assets/Panda2.png";
// import { ArrowRight } from "lucide-react";
import Panda from "../../../assets/Panda2.png";
import ScrollAnimation from "react-animate-on-scroll";
import { useEffect } from "react";
// import CelebrationPage from "./CelebrationPage";
import { progressService } from "../../../services/progressService";
// import "animate.css/animate.min.css";
import { usePopupWindowCloseHandler } from "../../../utils/useWindowCloseHandler.js";

const Conclusion = ({
  action,
  session_goal,
  insight,
  newSession,
  conclusion,
  yourInsight,
  sessionStoryId,
  userId,
  subsectionId,
  onSessionComplete,
}) => {
  const { user } = useContext(UserContext);
  const apiBaseURL = process.env.REACT_APP_BACKEND_API_URL;
  const [showFeedback, setShowFeedback] = useState(false);
  // const [showTextField, setShowTextField] = useState(false);
  const [completeSession, setCompleteSession] = useState(false);
  // const [userInput, setUserInput] = useState("");
  // const [currentPage, setCurrentPage] = useState(0);  // eslint-disable-line no-unused-vars
  const [currentPage, _setCurrentPage] = useState(0);  // eslint-disable-line no-unused-vars

  usePopupWindowCloseHandler(
    newSession,
    user?.user_id,
    apiBaseURL,
    !showFeedback
  );

  const sessionGoal = session_goal ? session_goal : "Session Goal Not Found.";
  console.log(`this is the actio taken ${action}`);

  const transformedActions = action
    ? Object.values(action).map((item) => ({
        name: item.action, // Use "action" as "name"
        frequency: item.frequency,
        accountability: item.name, // Use "name" as "accountability"
      }))
    : []; // Default to an empty array if action is undefined

  const [lines, setLines] = useState([]); // Start with one empty line
  console.log(transformedActions);

  // const addLine = () => {
  //   if (lines.length < 4) {
  //     setLines([...lines, ""]);
  //   }
  // };

  const handleInputChange = (index, value) => {
    const newLines = [...lines];
    newLines[index] = value;
    setLines(newLines);
  };

  // const backstory =
  //   "I am your guardian angel in this conversation, guiding you towards clarity and growth";

  const finalizeSession = async () => {
    if (newSession) {
      try {
        await fetch(`${apiBaseURL}/users/session/${newSession}/end`, {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
          },
        });
      } catch (error) {
        console.error("Error ending session:", error);
      }
    }

    if (typeof onSessionComplete === "function") {
      onSessionComplete();
      return;
    }

    if (userId && subsectionId) {
      await progressService.saveProgress(
        userId,
        subsectionId,
        { type: "ai", payload: {} },
        "completed"
      );
    }
  };

  const handleSubmit = async () => {
    try {
      const payload = {
        coachee_response: lines.join(",\n"),
        focus_popup_required: 1,
        record_from_focus_popup: 0,
        selected_focus_choice: 600,
        regenerate_with_intention: false,
        focus_options: "",
        alternate_focus_hypothesis: "",
        conversation_summary: "",
      };

      const response = await fetch(
        `${apiBaseURL}/users/${user.user_id}/session/${newSession}/step`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(payload),
        }
      );

      const data = await response.json();
      console.log(data);
      if (response.ok) {
        console.log("ok");
        console.log(data);
        setShowFeedback(true);

        const payload = {
          coach_conclusion: conclusion,
          coachee_conclusion: lines.join(",\n"),
          session_id: newSession,
        };
        console.log("this is the payload of conclution");
        console.log("Payload to send:", payload);
        await fetch(`${apiBaseURL}/conclusion_responses`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(payload),
        });
        await finalizeSession();
      } else {
        console.error("Error in regeneration:", data.detail);
      }
    } catch (error) {
      console.error("Error during regeneration:", error);
    }
  };

  const [showActions, setShowActions] = useState(true); // eslint-disable-line no-unused-vars
  const hasActions = transformedActions.length > 0;
  useEffect(() => {
    if (hasActions) {
      const interval = setInterval(() => {
        setShowActions((prev) => !prev);
      }, 7000); // Toggle every 7 seconds

      return () => clearInterval(interval);
    }
  }, [hasActions]);

  const toggleManually = () => {
    if (hasActions) {
      setShowActions((prev) => !prev);
    }
  };

  // for Three key Insights

  const addInsight = () => {
    if (lines.length < 3) {
      setLines([...lines, ""]); // Add an empty string to maintain input tracking
    }
  };

  // const moveToNextPage = () => {
  //   setCurrentPage((prevPage) => prevPage + 1);
  // };

  useEffect(() => {
    if (hasActions) {
      const interval = setInterval(() => {
        setShowActions((prev) => !prev);
      }, 10000); // Flip every 10 seconds

      return () => clearInterval(interval);
    }
  }, [hasActions]);

  return (
    <>
      <div className="fixed inset-0 bg-gray-700 bg-opacity-80 flex justify-center items-center z-50 font-serif overflow-y-auto">
        {!showFeedback ? (
          <>
            <div className="relative w-full lg:max-w-[900px] xl:max-w-[1000px] mt-20 rounded-lg mx-auto h-auto">
              <motion.div
                className="relative w-full grid grid-cols-2 p-2 sm:grid-cols-1 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-4 z-10 "
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5 }}
              >
                <div className="col-span-5">
                  {currentPage === 0 && (
                    <motion.div
                      className="p-4 sm:p-8 space-y-6"
                      initial={{ opacity: 0, x: -20 }}
                      animate={{ opacity: 1, x: 0 }}
                      exit={{ opacity: 0, x: 20 }}
                    >
                      <div className="w-full max-w-full sm:max-w-2xl lg:max-w-3xl mt-6 mx-auto p-4 sm:p-6 pb-24 space-y-6 bg-white relative  rounded-xl ">
                        <motion.div
                          className="text-center flex justify-center items-center space-x-2"
                          initial={{ opacity: 0, y: -20 }}
                          animate={{ opacity: 1, y: 0 }}
                          transition={{ duration: 0.6, ease: "easeOut" }}
                        >
                          <img
                            src={stars}
                            alt="Stars"
                            className="rotate-180 w-6 sm:w-8"
                          />
                          <h2 className="text-2xl sm:text-3xl md:text-4xl font-medium text-[#323232] text-mona font-gotham">
                            Your Session Summary
                          </h2>
                          <img src={stars} alt="Stars" className="w-6 sm:w-8" />
                        </motion.div>

                        {/* Session Focus */}
                        <div
                          onClick={toggleManually}
                          className="cursor-pointer relative"
                        >
                          <ScrollAnimation
                            animateIn="animate__fadeIn"
                            duration={1.5}
                            animateOnce={true}
                          >
                            <motion.div
                              className="bg-[#54B0AF] text-white rounded-xl flex flex-col md:flex-row items-start md:items-center justify-between space-y-4 md:space-y-0 md:space-x-4 "
                              initial={{ opacity: 0, x: -50 }}
                              animate={{ opacity: 1, x: 0 }}
                              transition={{
                                duration: 1.2,
                                delay: 0.2,
                                ease: "easeOut",
                              }}
                            >
                              <div className="flex">
                                <div className="flex-1 p-2 md:p-4 w-3/5">
                                  <h3 className="text-xl sm:text-3xl font-medium font-gotham">
                                    Session Focus
                                  </h3>
                                  <p className="text-lg leading-5 md:leading-6 sm:text-xl font-gotham">
                                    {sessionGoal}
                                  </p>
                                </div>
                                <div className="flex justify-end w-2/5">
                                  <img
                                    src={Panda}
                                    alt="Panda"
                                    className="w-full h-full "
                                  />
                                </div>
                              </div>
                            </motion.div>
                          </ScrollAnimation>
                        </div>

                        <motion.div
                          initial={{ opacity: 0, y: 20 }}
                          animate={{ opacity: 1, y: 0 }}
                          transition={{
                            duration: 1.2,
                            delay: 0.4,
                            ease: "easeOut",
                          }}
                        >
                          {transformedActions.length > 0 && (
                            <h3 className="text-2xl sm:text-3xl text-gray-800 font-medium font-gotham">
                              Action Commitments
                            </h3>
                          )}

                          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4 mt-4">
                            {transformedActions.length > 0 ? (
                              transformedActions.map((action, index) => {
                                const isTwoItems =
                                  transformedActions.length === 2;
                                const tileWidth = isTwoItems
                                  ? "sm:col-span-1 md:col-span-2"
                                  : "";

                                return (
                                  <motion.div
                                    key={index}
                                    className={`p-4 bg-white shadow-lg rounded-2xl border border-gray-200 ${tileWidth}`}
                                    initial={{ opacity: 0, scale: 0.9 }}
                                    animate={{ opacity: 1, scale: 1 }}
                                    transition={{
                                      duration: 0.4,
                                      delay: index * 0.1 + 0.5,
                                      ease: "easeOut",
                                    }}
                                  >
                                    <h4 className="text-[#323232] text-[18px] font-medium font-gotham">
                                      {action.name}
                                    </h4>
                                    <hr className="border-gray-300 my-2" />
                                    <p className="text-gray-500 text-md font-gotham">
                                      Accountability Partner:
                                      <br />
                                      <span className="font-medium text-[#323232] text-[17px] font-gotham">
                                        {action.accountability === "Myself"
                                          ? "Self-accountable"
                                          : action.accountability}
                                      </span>
                                    </p>
                                    <button className="justify-end items-end mt-2 px-4 py-2 bg-[#323232] text-white rounded-lg w-full font-gotham">
                                      {action.frequency}
                                    </button>
                                  </motion.div>
                                );
                              })
                            ) : (
                              <>
                                <div className="p-4 sm:p-6 bg-white w-full sm:col-span-2 md:col-span-3 shadow-lg rounded-2xl border border-gray-200">
                                  <h4 className="text-[#323232] text-xl font-medium font-gotham">
                                    Perspective Shift Summary
                                  </h4>
                                  <hr className="border-gray-300 my-2" />
                                  <p className="text-gray-500 text-md">
                                    {insight}
                                  </p>
                                </div>
                                {/* <div className="p-4 sm:p-6 bg-white w-full sm:col-span-2 md:col-span-3 shadow-lg rounded-2xl border border-gray-200">
                                  <h4 className="text-[#323232] text-xl font-medium font-gotham">
                                    Your Take on shift
                                  </h4>
                                  <hr className="border-gray-300 my-2" />
                                  <p className="text-gray-500 text-md font-gotham">
                                    {yourInsight}
                                  </p>
                                </div> */}
                              </>
                            )}
                          </div>
                        </motion.div>

                        {/* Next Button */}
                        {/* <motion.button
                          className="absolute bottom-4 right-4 bg-[#54B0AF] text-white py-2 px-5 rounded-full shadow-lg hover:bg-teal-600"
                          initial={{ opacity: 0, scale: 0.8 }}
                          animate={{ opacity: 1, scale: 1 }}
                          transition={{
                            duration: 1.6,
                            delay: 0.8,
                            ease: "easeOut",
                          }}
                          onClick={moveToNextPage}
                        >
                          <ArrowRight size={24} />
                        </motion.button> */}

                        <motion.button
                          initial={{ opacity: 0, y: -50 }}
                          animate={{ opacity: 1, y: 0 }}
                          transition={{ duration: 1.0, delay: 1.5 }}
                          className="mt-6 w-full bg-[#54B0AF] text-white px-6 py-2 rounded-lg hover:bg-teal-600 flex items-center justify-center"
                          onClick={() => {
                            setCompleteSession(true);
                            handleSubmit();
                          }}
                          disabled={completeSession}
                        >
                          {completeSession ? (
                            <div className="w-5 h-5 border-4 border-white border-t-transparent rounded-full animate-spin"></div>
                          ) : (
                            "Complete Session"
                          )}
                        </motion.button>
                      </div>
                    </motion.div>
                  )}

                  {currentPage === 1 && (
                    <motion.div
                      className="p-4 sm:p-8 space-y-6"
                      initial={{ opacity: 0, x: 20 }}
                      animate={{ opacity: 1, x: 0 }}
                      exit={{ opacity: 0, x: -20 }}
                    >
                      <div className="flex justify-center items-center min-h-screen">
                        <motion.div
                          initial={{ opacity: 0, y: -50 }}
                          animate={{ opacity: 1, y: 0 }}
                          transition={{ duration: 0.5 }}
                          className="flex flex-col w-full max-w-2xl md:max-w-4xl p-4 sm:p-6 bg-white shadow-xl rounded-2xl items-center gap-4"
                        >
                          <motion.div
                            initial={{ opacity: 0, y: -50 }}
                            animate={{ opacity: 1, y: 0 }}
                            transition={{ duration: 1.0, delay: 0.2 }}
                            className="text-xl sm:text-2xl font-medium mb-4 flex items-center"
                          >
                            <img
                              src={stars}
                              alt=""
                              className="rotate-180 w-6 sm:w-8 mr-2"
                            />
                            <p className="font-gotham">Three Key Takeaways</p>
                            <img
                              src={stars}
                              alt=""
                              className="w-6 sm:w-8 ml-2"
                            />
                          </motion.div>

                          <motion.div
                            initial={{ opacity: 0, y: -50 }}
                            animate={{ opacity: 1, y: 0 }}
                            transition={{ duration: 1.5, delay: 0.4 }}
                            className="bg-[#54B0AF] rounded-lg flex items-center relative w-full"
                          >
                            <div className="flex flex-row">
                              <div className="w-3/5 md:w-4/5 p-4">
                                <h2 className="text-lg sm:text-xl leading-4 md:leading-6 font-bold text-white font-gotham">
                                  Personalized Report Coming!
                                </h2>
                                <p className="text-white leading-4 md:leading-6 mt-1 md:mt-3 text-sm md:text-lg font-medium font-gotham">
                                  Your personalized executive report is being
                                  prepared - expect it in your inbox within a
                                  day!
                                </p>
                              </div>
                              <div className="w-2/5 md:w-1/5 ">
                                <img
                                  src={Panda2}
                                  alt=""
                                  className="w-full h-full"
                                />
                              </div>
                            </div>
                          </motion.div>

                          <motion.div
                            initial={{ opacity: 0, y: -50 }}
                            animate={{ opacity: 1, y: 0 }}
                            transition={{ duration: 2.0, delay: 0.6 }}
                            className="mb-4 shadow-lg rounded-xl p-2 sm:p-4 w-full"
                          >
                            {lines.map((line, index) => (
                              <motion.div
                                key={index}
                                initial={{ opacity: 0, y: -50 }}
                                animate={{ opacity: 1, y: 0 }}
                                transition={{
                                  duration: 0.5,
                                  delay: 0.2 * index,
                                }}
                                className="mb-4 p-2"
                              >
                                <p className="text-gray-600 mb-2 flex items-center gap-2">
                                  <img src={Vector2} alt="" className="w-5" />
                                  <input
                                    type="text"
                                    placeholder={`Reflection #${index + 1}`}
                                    className="w-full outline-none text-sm sm:text-base"
                                    value={line}
                                    onChange={(e) =>
                                      handleInputChange(index, e.target.value)
                                    }
                                  />
                                </p>
                                <hr className="text-gray-500" />
                              </motion.div>
                            ))}

                            {lines.length < 3 && (
                              <motion.button
                                onClick={addInsight}
                                initial={{ opacity: 0, y: -50 }}
                                animate={{ opacity: 1, y: 0 }}
                                transition={{ duration: 0.8, delay: 1.0 }}
                                className="w-full sm:w-[180px] bg-gray-800 text-white py-2 rounded-lg mt-4 hover:bg-gray-700"
                              >
                                + Takeaway
                              </motion.button>
                            )}
                            <p className="text-[#888888] py-2 font-gotham">
                              Capture your most important reflections from this
                              session
                            </p>
                          </motion.div>

                          <motion.button
                            initial={{ opacity: 0, y: -50 }}
                            animate={{ opacity: 1, y: 0 }}
                            transition={{ duration: 1.0, delay: 1.5 }}
                            className="mt-6 w-full bg-[#54B0AF] text-white px-6 py-2 rounded-lg hover:bg-teal-600 flex items-center justify-center"
                            onClick={() => {
                              setCompleteSession(true);
                              handleSubmit();
                            }}
                            disabled={completeSession}
                          >
                            {completeSession ? (
                              <div className="w-5 h-5 border-4 border-white border-t-transparent rounded-full animate-spin"></div>
                            ) : (
                              "Complete Session"
                            )}
                          </motion.button>
                        </motion.div>
                      </div>
                    </motion.div>
                  )}
                </div>
              </motion.div>
            </div>
          </>
        ) : (
          <div className="text-white text-lg font-gotham">
            Completing your session...
            {/*
            {hasActions ? (
              <CelebrationPage
                newSession={newSession}
                useCase="after_actions_popup"
              />
            ) : (
              <CelebrationPage
                newSession={newSession}
                useCase="finished_strong"
                sessionStoryId={sessionStoryId}
              />
            )}
            */}
          </div>
        )}
      </div>
    </>
  );
};

export default Conclusion;
